export function getOffsetForPage(page: number, perPage: number) {
    const offset = Math.max(0, (page - 1) * perPage);

    return isNaN(offset) ? 0 : offset;
}

export function getNumberOfPages(total: number, perPage: number) {
    const pages = Math.max(1, Math.ceil(total / perPage));

    return isNaN(pages) ? 1 : pages;
}
